import { render, staticRenderFns } from "./user_action.vue?vue&type=template&id=3a101d88&scoped=true"
import script from "./user_action.vue?vue&type=script&lang=ts"
export * from "./user_action.vue?vue&type=script&lang=ts"
import style0 from "./user_action.vue?vue&type=style&index=0&id=3a101d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a101d88",
  null
  
)

export default component.exports